export default "__VITE_ASSET__DsUNkoBp__"